var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',_vm._l((_vm.movies),function(movie){return _c('Movie',{key:movie.mov_id,attrs:{"id":movie.mov_id,"name":movie.mov_name,"description":movie.mov_desc,"year":movie.mov_year,"director":movie.mov_director}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }